import { captureError } from '@otto-ec/global-resources/apm';
import { log } from '@shared/log.browser.ts';

/*                                                 */
const DEFAULT_LABELS = { team: 'reptile', service: 'dundee' };

export function createApmErrorHandlerBrowser(scope: string): (error: unknown, reset: () => void) => void {
    return async function onerror(error: unknown, _reset: () => void) {
        log.scope(scope).error(error);
        captureError(error instanceof Error ? error : new Error(String(error)), DEFAULT_LABELS, { type: scope });
    };
}
